import { mount } from 'svelte'
import './app.css'
import App from './App.svelte'
import { login, logout } from './services/auth-service'

const originalFetch = window.fetch.bind(window)
window.fetch = async (input, init) => {
  const response = await originalFetch(input, init)
  if (response.status === 401) {
    logout()
  }
  return response
}

const initAuth = async () => {
  try {
    const response = await originalFetch('/api/auth/me', {
      method: 'GET',
      credentials: 'include'
    })

    if (response.ok) {
      const user = await response.json()
      login(user)
      return
    }

    if (response.status === 401) {
      logout()
      return
    }
  } catch (error) {
    console.error('Auth failed', error)
  }

  logout()
}

void initAuth()

const target = document.getElementById('app')
if (!target) {
  throw new Error('Missing #app mount target')
}

const app = mount(App, {
  target,
})

export default app


